import { Injectable } from '@angular/core';
import { HomeMessageDto } from '../../admin/admin-general/dto/home.message.dto';
import { ApiService } from './api.service';
import { environment } from '../../environments/environment';
import { ApplicationConfigurationDto } from '../../admin/admin-general/dto/application-configuration.dto';

@Injectable({
  providedIn: 'root',
})
export class AdminService {
  constructor(private readonly api: ApiService) {}

  public async setHomeMessage(message: string): Promise<void> {
    return this.api.post<void, HomeMessageDto>(environment.api.home, new HomeMessageDto(message));
  }

  public async getHomeMessage(): Promise<HomeMessageDto> {
    return this.api.get<HomeMessageDto>(environment.api.home);
  }

  public async getApplicationConfiguration(): Promise<ApplicationConfigurationDto> {
    return this.api.get<ApplicationConfigurationDto>(environment.api.applicationConfiguration);
  }

  public async setApplicationConfiguration(dto: ApplicationConfigurationDto): Promise<void> {
    return this.api.post<void, ApplicationConfigurationDto>(environment.api.applicationConfiguration, dto);
  }
}
